<div id="resources-general" class="tools-and-resources tools-and-resources--downloads">
  <div class="container">
    <!--breadcrumbs-->
    @if (!userLoggedIn || (userLoggedIn && (!webEnabled))) {
      <div class="breadcrumbs--page-nav">
        <div class="container">
          <p>
            <a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span>
            <a [routerLink]="'/flu-vaccine-resources'">{{"statictext.toolsnresources" | cxTranslate}}</a><span> &gt; </span>
            <strong [innerHTML]="componentdata?.tileHeadLine"></strong>
          </p>
        </div>
      </div>
    }
    <div class="coding-billing-sbs coding-billing-sbs--download">
      <div class="container tools-and-resources-container">
        <!--Top Left Container-->
        <div class="coding-billing-sbs__left">
          <div class="coding-billing-sbs__content">
            <!--HEADER-->
            @if (componentdata?.tileHeadLine) {
              <h1 class="angle-header" [innerHTML]="componentdata?.tileHeadLine"></h1>
            }
            <!--description-->
            @if (componentdata?.headerDescription) {
              <p [innerHTML]="componentdata?.headerDescription"></p>
            }
            <!--used href here need clarification-->
            <!-- <a *ngIf="componentdata?.headerDownloadLabel" class="button--hero-outline-red"
            [ngClass]="{ 'disable': componentdata?.headerDownloadLabel == 'Coming Soon'}"
            [attr.disabled]="componentdata?.headerDownloadLabel == 'Coming Soon' ? true : null"
            [href]="getpdf(componentdata?.headerDownloadMedia)"
            target="_blank">{{componentdata?.headerDownloadLabel}}
          </a> -->
          @if (componentdata?.toolkitEntries?.length < 1) {
            <button
              type="button"
              class="button--hero-outline-red"
              [ngClass]="{ 'disable': componentdata?.headerDownloadLabel == 'Coming Soon' }"
              [disabled]="componentdata?.headerDownloadLabel == 'Coming Soon'"
              (click)="onHeaderMediaClick($event)">
              {{ componentdata?.headerDownloadLabel }}
            </button>
          }
          
          @if (isVideoModalOpen) {
            <div class="video-modal-backdrop">

              <div class="video-modal-wrapper">
            
                <button
                  type="button"
                  class="video-modal-close"
                  aria-label="Close Video"
                  (click)="closeVideoModal()">
                  ×
                </button>
            
                <div class="video-modal-player">
                  <iframe
                    [src]="safeVideoUrl"
                    allowfullscreen
                    frameborder="0">
                  </iframe>
                </div>
            
              </div>
            
            </div>
          }
          <!--for CPT Code-->
          @if (componentdata?.text1content) {
            <p class="coding-billing-sbs__footnotes" [innerHTML]="componentdata?.text1content"></p>
          }
        </div>
        <!-- for mobile version-->
        <div class="coding-billing-sbs__resource-notes mobile_Coding_Billing_Sbs_Resource_notes">
          <img [src]="getImage(componentdata?.tileImage)" [alt]="componentdata?.tileImage.altText">
          <div class="coding-billing-sbs__resource-notes-list">
            <div class="coding-billing-sbs__resource-notes-list-header">
              <h3 [innerHTML]="componentdata?.resourceNotesLabel"></h3>
              <img role="presentation" alt="Attributes Checklist"
                src="assets/images/resources-check.png">
              </div>
              <div [innerHTML]="componentdata?.resourceNotesDescription"></div>
            </div>
          </div>
          <!--pdf download list-->
          <div class="download-list">
            <!-- <div class="download-list__header" *ngIf="componentdata?.toolkitEntries?.length > 0">
            <button class="btn--download downloadBtn" (click)="downloadpdfs()">
              Download Selected
              <img role="presentation" alt="Download" src="../../../../assets/images/icon-download.svg">
            </button>
          </div> -->
          <div class="download-list__body" id="download_toolkit">
            @for (item2 of componentdata?.toolkitEntries; track item2) {
              <div class="download-list__item">
                <div class="checkbox-container">
                  <label class="label-container flex-container">
                    <span class="labelTransformation" [innerHTML]="item2?.toolkitHeader"></span>
                    <input type="checkbox" class="hide-checkbox" id="download_item_chk_1"
                      (change)="downloadselectedpdf($event, getpdf(item2?.toolkitMedia))">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <p class="doc_size">{{ item2?.toolkitMedia.size }} MB</p>
                  <!-- <span class="doc_size">12.6 MB</span> -->
                </div>
              }
            </div>

            @if (componentdata?.toolkitEntries?.length > 0) {
              <a class="button--hero-outline-red download-selected" (click)="downloadpdfs()">Download Selected
              </a>
            }
          </div>
        </div>
        <!--Top Right side Description-->
        <div class="coding-billing-sbs__right">
          <div class="coding-billing-sbs__resource-notes">
            <img [src]="getImage(componentdata?.tileImage)" [alt]="componentdata?.tileImage.altText">
            <div class="coding-billing-sbs__resource-notes-list">
              <div class="coding-billing-sbs__resource-notes-list-header">
                <h3 [innerHTML]="componentdata?.resourceNotesLabel"></h3>
                <img role="presentation" alt="Attributes Checklist"
                  src="assets/images/resources-check.png">
                </div>
                <div [innerHTML]="componentdata?.resourceNotesDescription"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Acess Resources Desktop Version-->
    <div class="resources desktop_Access_Resources">
      <div class="container access-resources-container">
        <div class="row-flex carousel-container-row feat-resources__headline">
          <div class="row-flex access-financial-resources-header--row">
            <div class="col-sm-12 header--container">
              <h2>
                <span>{{"statictext.additonalresources" | cxTranslate}}</span>
                <div class="global_line"></div>
              </h2>
            </div>
          </div>
        </div>
        <div id="clinical-resources-financial" class="row-flex carousel--three-card resources-card--row">
          @for (data1 of finalArray; track data1) {
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 cards-pl-0-mobile">
              <div class="resources--card">
                <img [src]="getImage(data1?.tileImage)"
                  [alt]="data1?.tileImage.altText"
                  class="card-img">
                  <div class="resources--card-container">
                    <p class="resources--card-eyebrow" [innerHTML]="data1?.tileType"></p>
                    <p class="resources--card-title" [innerHTML]="data1?.tileHeadLine"></p>
                    <p class="resources--card-paragraph" [innerHTML]="data1?.tileDescription"></p>
                  </div>
                  <a [href]="data1?.tileLink">
                    <button class="resources--card-btn">
                      <span [innerHTML]="data1?.tileLinkLabel"></span>
                      <img src="/assets/images/arrow-right.svg">
                    </button>
                  </a>
                </div>
              </div>
            }
          </div>

        </div>
      </div>
      <!--Acess Resources Mobile Version-->
      <div class="resources mobile_Access_Resources">
        <div class="container access-resources-container">
          <div class="row-flex carousel-container-row feat-resources__headline">
            <div class="row-flex access-financial-resources-header--row">
              <div class="col-sm-12 header--container">
                <h2>
                  <span>{{"statictext.additonalresources" | cxTranslate}}</span>
                </h2>
              </div>
            </div>
          </div>
          <div id="clinical-resources-financial" class="row-flex carousel--three-card resources-card--row">
            <div id="resourcesCarousel" class="carousel slide" data-bs-ride="false">
              <ol class="carousel-indicators">
                @for (data1 of finalArray; track data1; let i = $index) {
                  <li [attr.data-bs-target]="'#resourcesCarousel'"
                  [attr.data-bs-slide-to]="i" [class.active]="i === 0"></li>
                }
              </ol>

              <div class="carousel-inner">
                @for (data1 of finalArray; track data1; let i = $index) {
                  <div class="carousel-item"
                    [class.active]="i === 0">
                    <div class="resources--card col-md-7">
                      <img [src]="getImage(data1?.tileImage)"
                        [alt]="data1?.tileImage.altText"
                        class="card-img">
                        <div class="resources--card-container">
                          <p class="resources--card-eyebrow" [innerHTML]="data1?.tileType"></p>
                          <p class="resources--card-title" [innerHTML]="data1?.tileHeadLine"></p>
                          <p class="resources--card-paragraph" [innerHTML]="data1?.tileDescription"></p>
                        </div>
                        <a [href]="data1?.tileLink">
                          <button class="resources--card-btn">
                            <span [innerHTML]="data1?.tileLinkLabel"></span>
                            <img src="/assets/images/arrow-right.svg">
                          </button>
                        </a>
                      </div>
                    </div>
                  }
                </div>
                <a class="carousel-control-prev d-none" href="#resourcesCarousel" role="button" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">{{"statictext.previous" | cxTranslate}}</span>
                </a>
                <a class="carousel-control-next d-none" href="#resourcesCarousel" role="button" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">{{"statictext.next" | cxTranslate}}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!--View All Resources Button-->
        <div class="row-flex ">
          <div class="col-xs-12 text-center view-resources--row">
            <a routerLink="{{componentdata?.viewAllResourcesLink?.url}}">
              <button
              class="button--view-resources-outline-grey">{{componentdata?.viewAllResourcesLink?.linkName}}</button>
            </a>
          </div>
        </div>
      </div>